import React from "react"
import { AppButtonIcon } from "@components"
import { useForceReport } from "Pages/ReportsAlerts/Reports/@hooks"
import { CircularProgress } from "@mui/material"


export default function ReportTableForceAction({ showForceButton }) {

	const { isLoading, setIsLoading } = useForceReport()

	if (isLoading) return <CircularProgress size={17} sx={{ m: 0.2 }}/>

	return showForceButton && <AppButtonIcon icon="circle-stop" tooltip="Stop Execution" onClick={setIsLoading}/>
}